import React, { Component } from 'react';
import VacancyCard from '../../components/VacancyCard';
import { Link } from 'react-router-dom';
import { FormApplication } from '../../components/Form';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Preloader from '../../components/Preloader';
import ErrorMessage from '../../components/ErrorMessage';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadVacancy } from '../../actions/VacancyActions';
import { loadCities } from '../../actions/CitiesActions';

function shuffleArray(array) {
  let i = array.length - 1;
  for (; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

class PageVacanciesCard extends Component {
  static requestData(store, match) {
    return requestAll([loadVacancies, () => loadVacancy(match.params.vacanciesCard), loadCities], store);
  }

  componentDidMount() {
    this.props.actions.loadVacancies(this.props.filter, true);
    this.props.actions.loadCities();
    this.props.actions.loadVacancy(this.props.match.params.vacanciesCard);
  }
  render() {
    const shuffled = shuffleArray(this.props.vacancies);

    if (this.props.hasErrored) {
      return <ErrorMessage/>;
    }

    if (this.props.isLoading) {
       return <Preloader/>;
    }

    return (
      <div>
        <VacancyCard {...this.props} />
        <div id="toResumeFormInVacancy" className="container container--indentVertical">
          <div className="row">
            <div className="col col--9 colTablet--12">
              <h2 id="toVacancyForm" className="text text--h2 text--top16">Заинтересованы?</h2>
              <div className="text text--bottom24">Заполните и&nbsp;отправьте краткую анкету на&nbsp;должность «{this.props.vacancy.name}», чтобы мы&nbsp;могли связаться с&nbsp;вами и&nbsp;пригласить на&nbsp;собеседование.</div>
              <FormApplication apiUrl='/vacancy/create/' vacancy={this.props.vacancy} cities={this.props.cities} />
            </div>
            {
              (shuffled && shuffled.length > 1) &&
              <div className="col col--3 colTablet--12">
                <h2 className="text text--h3 text--top16">Другие вакансии</h2>
                <div className="text">
                  {
                    shuffled.slice(0,  shuffled.length > 2 ? shuffled.length - (shuffled.length - 2) : shuffled.length - 1).map((vacancy, index) =>
                      <p key={`vacancy-${index}`}><Link to={`vacancy${vacancy.id}`}>{vacancy.name}</Link></p>
                    )
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.vacanciesCard !== this.props.match.params.vacanciesCard) {
      this.props.actions.loadVacancy(nextProps.match.params.vacanciesCard);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      cities: state.cities.list,
      vacancy: state.vacancy.item,
      vacancies: state.vacancies.list,
      hasErrored: state.vacancy.hasErrored,
      isLoading: state.vacancy.isLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({ loadVacancies, loadVacancy, loadCities }, dispatch),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageVacanciesCard));




// WEBPACK FOOTER //
// ./src/pages/PageVacanciesCard/index.js